















import { defineComponent, computed } from '@vue/composition-api';
import PackageTabletUpCard from './PackageTabletUpCard.vue';
import trackersPackageIncludedItems from './trackersPackageIncludedItems.json';
import trackersBagPackageIncludedItems from './trackersBagPackageIncludedItems.json';
import PackageIncludedItemsCarousel from './PackageIncludedItemsCarousel.vue';

export default defineComponent({
  name: 'PackageIncludedItems',
  components: {
    PackageTabletUpCard,
    PackageIncludedItemsCarousel,
  },
  setup() {
    // @ts-ignore
    const { $router } = useNuxtApp();
    const items = computed(() => {
      const routeNames = ['shop-products-fightcamp-trackers', 'gqbox', 'shop-products-fightcamp-console'];
      if (routeNames.includes($router.history.current.name)) {
        return trackersPackageIncludedItems;
      }
      return trackersBagPackageIncludedItems;
    });
    const getJustifyPosition = computed(() => (items.value.length > 3 ? 'fc-justify-between' : 'fc-justify-around'));

    return {
      items,
      getJustifyPosition,
    };
  },
});
